"use client";
/*
 * Documentation:
 * CardSysMessage — https://app.subframe.com/ae91faa555e6/library?component=CardSysMessage_d8c69be7-6456-490a-8732-3a201fbadb25
 */

import React from "react";
import * as SubframeUtils from "../utils";

interface CardSysMessageRootProps extends React.HTMLAttributes<HTMLDivElement> {
  mainContent?: React.ReactNode;
  dateTime?: React.ReactNode;
  className?: string;
}

const CardSysMessageRoot = React.forwardRef<
  HTMLElement,
  CardSysMessageRootProps
>(function CardSysMessageRoot(
  { mainContent, dateTime, className, ...otherProps }: CardSysMessageRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "flex max-w-[576px] flex-col items-start gap-2 rounded-md bg-neutral-50 px-4 py-2",
        className
      )}
      ref={ref as any}
      {...otherProps}
    >
      <div className="flex items-center gap-2">
        {mainContent ? (
          <span className="text-body font-body text-default-font">
            {mainContent}
          </span>
        ) : null}
        {dateTime ? (
          <span className="text-body font-body text-brand-700">{dateTime}</span>
        ) : null}
      </div>
    </div>
  );
});

export const CardSysMessage = CardSysMessageRoot;
